import { render, staticRenderFns } from "./InquiryShopInfor.vue?vue&type=template&id=f69817f8&scoped=true&"
import script from "./InquiryShopInfor.vue?vue&type=script&lang=js&"
export * from "./InquiryShopInfor.vue?vue&type=script&lang=js&"
import style0 from "./InquiryShopInfor.vue?vue&type=style&index=0&id=f69817f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69817f8",
  null
  
)

export default component.exports